import axios from "@/plugins/axios";

const sendHelpCenterRequest = (request) => {
  return axios.post("/help-center-request", request);
};

export default {
  sendHelpCenterRequest,
};
